module.exports = __webpack_public_path__ + "static/media/U1-T2-3-1d.848a9cd5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-3-1d.svg
// module id = 571
// module chunks = 0